import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('helpLink');

    return {
        HELP: t('help')
    };
};

export default useTranslation;
